<style lang="less" scoped>
.FromCenter {margin-top: 20px;}
.btn-wr{text-align: center;}
/deep/ .el-form-item__error {font-size: 14px;}
</style>

<template>
  <div class="FromCenter">
    <el-form ref="verificationForm" :model="verificationForm"  :rules="verificationFormRules" class="demo-ruleForm">
      <el-form-item label="请选择验证方式">
        <el-select v-model="verificationForm.type" placeholder="请选择验证方式">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="account" label="请输入绑定的手机号或者邮箱">
        <el-input v-model="verificationForm.account" type="text" placeholder="请输入绑定的手机号或者邮箱"></el-input>
      </el-form-item>
    </el-form>
    <div class="btn-wr">
      <el-button type="primary" @click="checkSecurityQuestion()">确认</el-button>
    </div>
  </div>
</template>

<script>
/**
 * 安进
 * 忘记密码——确认账号
 */
export default {
  data()
  {
    let validateAccount = (rule, value, callback) =>
    {
      let regtel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (this.verificationForm.type === 'telno')
      {
        if (value === '')
          callback(new Error('请输入绑定的手机号'))
        else
        {
          if (!regtel.test(value))
            callback(new Error('请输入正确绑定的手机号'))
          else
            callback()
        }
      }
      else if (this.verificationForm.type === 'email')
      {
        if (value === '')
          callback(new Error('请输入绑定的邮箱'))
        else
          callback()
      }
      else
        callback()
    }
    return {
      options: [{
        value: 'telno',
        label: '手机'
      }, {
        value: 'email',
        label: '邮箱'
      }],
      verificationForm: {
        no: '',
        type: '',
        account: '',
        value: '',
        userid: ''
      },
      verificationFormRules: {
        account: [{ validator: validateAccount, trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 账号验证
    checkSecurityQuestion()
    {
      if (this.verificationForm.type !== '' && this.verificationForm.account !== '')
      {
        this.$refs.verificationForm.validate(valid =>
        {
          if (valid)
          {
            let paras = {
              cmd: 'verifyAccount',
              number: this.verificationForm.account,
              type: this.verificationForm.type
            }
            window.post.getLoginSvr(paras).then(ret =>
            {
              if (ret.ret === 0)
              {
                this.verificationForm.no = ret.no
                this.verificationForm.value = ret.value
                this.verificationForm.userid = ret.userid
                this.$parent.activeadd()
                this.$emit('fun', this.verificationForm)
              }
              else if (ret.ret === 1)
              {
                switch (ret.errcode)
                {
                case 'errNoUser':
                  this.$message({message: '此用户暂未注册', type: 'error', customClass: 'mzindex'})
                  break
                case 'errNoType':
                  this.$message({message: '该用户暂未绑定手机号或邮箱', type: 'error', customClass: 'mzindex'})
                  break
                case 'errType':
                  this.$message({message: '暂无此验证方式', type: 'error', customClass: 'mzindex'})
                  break
                }
              }
            })
          }
          else if (this.verificationForm.type === 'telno')
            this.$message({message: '请填写正确的手机号', type: 'warning', customClass: 'mzindex'})
          else if (this.verificationForm.type === 'email')
            this.$message({message: '请填写正确的邮箱', type: 'warning', customClass: 'mzindex'})
        })
      }
      else if (this.verificationForm.type === '')
        this.$message({message: '请选择验证方式', type: 'error', customClass: 'mzindex'})
      else if (this.verificationForm.account === '')
        this.$message({message: '请输入绑定的手机号或者邮箱', type: 'error', customClass: 'mzindex'})
      else
        this.$message({message: '请选择验证方式，以及输入绑定的手机号或者邮箱', type: 'error', customClass: 'mzindex'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/wjmm/VerificationWay.vue